(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["herosection"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const root = document.querySelector(".custom-slider");
  if (!root) return;

  const slides = Array.from(root.querySelectorAll(".custom-slide"));
  const prevBtn = root.querySelector(".slider-arrow.prev");
  const nextBtn = root.querySelector(".slider-arrow.next");
  const dotsContainer = root.querySelector(".slider-dots");
  let current = 0;
  let autoSlideTimer = null;
  const AUTO_DELAY = 4000;
  const TOUCH_THRESHOLD = 40;

  // Build dots
  slides.forEach((_, i) => {
    const btn = document.createElement("button");
    btn.className = "dot";
    btn.type = "button";
    btn.setAttribute("aria-label", "Go to slide " + (i + 1));
    btn.addEventListener("click", () => { showSlide(i); resetAuto(); });
    dotsContainer.appendChild(btn);
  });
  const dots = Array.from(dotsContainer.querySelectorAll(".dot"));

  function showSlide(index) {
    slides.forEach((s, i) => s.classList.toggle("active", i === index));
    dots.forEach((d, i) => d.classList.toggle("active", i === index));
    current = index;
  }

  function nextSlide() { showSlide((current + 1) % slides.length); }
  function prevSlide() { showSlide((current - 1 + slides.length) % slides.length); }

  function startAuto() {
    stopAuto();
    autoSlideTimer = setInterval(nextSlide, AUTO_DELAY);
  }
  function stopAuto() { if (autoSlideTimer) { clearInterval(autoSlideTimer); autoSlideTimer = null; } }
  function resetAuto() { stopAuto(); startAuto(); }

  prevBtn && prevBtn.addEventListener("click", () => { prevSlide(); resetAuto(); });
  nextBtn && nextBtn.addEventListener("click", () => { nextSlide(); resetAuto(); });

  // Keyboard navigation
  root.addEventListener("keydown", (e) => {
    if (e.key === "ArrowLeft") { prevSlide(); resetAuto(); }
    if (e.key === "ArrowRight") { nextSlide(); resetAuto(); }
  });

  // Touch swipe for mobile
  let touchStartX = null;
  root.addEventListener("touchstart", (e) => {
    touchStartX = e.touches[0].clientX;
  }, { passive: true });
  root.addEventListener("touchend", (e) => {
    if (touchStartX === null) return;
    const dx = e.changedTouches[0].clientX - touchStartX;
    touchStartX = null;
    if (Math.abs(dx) > TOUCH_THRESHOLD) {
      if (dx < 0) nextSlide(); else prevSlide();
      resetAuto();
    }
  });

  // Ensure videos attempt to play (user gesture policy)
  const videos = root.querySelectorAll("video");
  function ensureVideoPlayback() {
    videos.forEach(video => {
      if (video && (video.paused || video.readyState < 3)) {
        video.play().catch(() => {});
      }
    });
  }
  ['click','touchstart','scroll','keydown','mousemove','focus'].forEach(evt => {
    document.addEventListener(evt, ensureVideoPlayback, { passive: true });
  });
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') ensureVideoPlayback();
  });
  window.addEventListener('focus', ensureVideoPlayback);

  // Initialize
  if (slides.length) {
    showSlide(0);
    startAuto();
  }

  // Pause auto-rotation while user hovers (desktop)
  root.addEventListener("mouseenter", stopAuto);
  root.addEventListener("mouseleave", startAuto);

  // Accessibility: make dots tabbable
  dots.forEach(d => d.tabIndex = 0);

  // ---------------------------
  // New: Show arrows on banner (default) and ensure they also appear when menu opens
  // ---------------------------
  const sliderRoot = root;

  // Function that attempts to detect if mobile/menu is open.
  function isMenuOpen() {
    const body = document.body;
    const checks = [
      () => body.classList.contains('menu-open'),
      () => body.classList.contains('nav-open'),
      () => body.classList.contains('mobile-nav--open'),
      () => body.classList.contains('site-nav--open'),
      () => document.querySelector('.mobile-menu') && document.querySelector('.mobile-menu').classList.contains('is-open'),
      () => {
        const nav = document.querySelector('.mobile-nav, .site-navigation, .site-nav');
        return nav && nav.getAttribute('aria-hidden') === 'false';
      },
      () => {
        // For themes that use aria-expanded on the menu toggle button
        const btn = document.querySelector('[aria-expanded]');
        return btn && btn.getAttribute('aria-expanded') === 'true';
      }
    ];

    return checks.some(fn => {
      try { return !!fn(); } catch (e) { return false; }
    });
  }

  // Make arrows visible on init (so they show on the banner)
  if (sliderRoot) sliderRoot.classList.add('show-arrows');

  // We still want to ensure arrows appear when the menu opens.
  // IMPORTANT: do NOT remove the class when menu closes — we want arrows visible on banner by default.
  function updateArrowsVisibility() {
    if (!sliderRoot) return;
    if (isMenuOpen()) sliderRoot.classList.add('show-arrows');
    // intentionally do NOT remove the class here so arrows remain visible on the banner
  }

  // initial detection (also covers cases where menu is already open)
  updateArrowsVisibility();

  // listen for clicks on potential toggles (works on many themes)
  document.addEventListener('click', () => {
    // run visibility update on click - short timeout to allow DOM toggles to apply
    setTimeout(updateArrowsVisibility, 10);
  }, { passive: true });

  // observe body attribute/class changes (for themes that add/remove classes to body)
  const mo = new MutationObserver(() => updateArrowsVisibility());
  mo.observe(document.body, { attributes: true, attributeFilter: ['class', 'aria-hidden'] });

  // also observe common menu elements if present
  const menuEls = document.querySelectorAll('.mobile-menu, .mobile-nav, .site-navigation, .site-nav');
  if (menuEls.length) {
    menuEls.forEach(el => {
      try { mo.observe(el, { attributes: true, attributeFilter: ['class', 'aria-hidden'] }); } catch (e) {}
    });
  }

  // clean up on unload (optional)
  window.addEventListener('unload', () => { mo.disconnect(); });
});

  } catch(e) { console.error(e); }
})();
})();
